<template>
  <div class="pb-2">
    <table class="table table-sm">
      <thead>
      <tr>
        <th>{{transEdit('Dag')}}</th>
        <th>{{transEdit('Beskrivning')}}</th>
        <th><button type="button" class="btn btn-sm bg-primary table-button text-white border " @click.prevent="addRow"><i class="fa fa-plus"></i> Lägg till rad</button>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(val, index) in days">
        <th class="mt-2 w-1/2"><vue-ctk-date-time-picker v-model="val.date" name="date_val[]" locale="sv" :only-date="true" date-format="YYYY-MM-DD" format="YYYY-MM-DD" formatted="YYYY-MM-DD" label="Välj datum" ></vue-ctk-date-time-picker></th>
        <td class="w-1/2"><input class="w-full" type="text" name="name[]" :value="val.name"></td>
        <td class=" w-1/2 mt-1">
          <button class="btn btn-outline border border-danger text-danger" v-on:click.prevent="deleteEvent(index)" style="margin-top: 4px;">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </td>
        <input type="hidden" name="date[]" :value="val.date">
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    red_days: {
      type: Array,
      required: true,
    },
    create: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      days: this.red_days,
    }
  },
  methods: {
    deleteEvent: function (index) {
      if(this.create) {
        this.days.splice(index, 1);
      } else {
        axios.delete(`/red_days/${this.days[index].id}`)
          .then((response) => {
            this.days.splice(index, 1);
          }, (error) => {
          });
      }
    },
    addRow: function (e) {
      e.stopPropagation();
      let nextId = this.days.length;
      let newRow = {
        id: ++nextId,
        name: '',
        date: '',
      };
      this.days.push( newRow );
    }
  }
}
</script>

<style scoped>
.table-button {
  width: 7rem;
}

  input {
    padding: .5rem;
    border-radius: 2px;
    border-width: 1px;
  }

/*.table td {*/
/*  padding: .5rem;*/
/*}*/
.mt-1 {
  margin-top: .25rem;
}

.table {
  width: 100%;
}

.table > thead > tr {
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 0;
  border-bottom-width: 2px;
}

th {
  text-align: left;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding-bottom: 0.25rem;
}

.table tr {
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.table td {
  padding: 0.5rem;
}

/*.table.table-hover tr:hover {*/
/*  @apply bg-primary-lightest;*/
/*}*/

.table.table-hover thead > tr:hover {
  background-color: transparent;
}


.w-1\/2 {
  width: 50%;
}
td.shrink {
  width: 1px;
  white-space: nowrap;
}

td.header-separator {
  font-size: 1.125rem;
  font-weight: 600;
}
</style>
